(function ($, window, document) {

    // local variable initialization
    var searchInputMain = document.getElementById('main-navbar-search-input'); // input in the head navi
    var searchResultsContainer = document.getElementsByClassName('main-navbar__predictive-search-results');
    var autoCompleteContainer = document.getElementsByClassName('main-navbar__btns');

    // add handler to execute azure ai search suggestions on typing to the main navigatin search input
    if (searchInputMain) {

        $(function () {
            var isAutoCompleteEnabled = $('.main-navbar__search').hasClass('is-autocomplete');
            if (!isAutoCompleteEnabled) {
                return;
            }
                
                // autocomplet function
            $(".main-navbar__search-input").autocomplete({
                source: [
                    function (text, add) {
                        if (!text) {
                            return;
                        }
                        var culture = autoCompleteContainer[0].dataset.currentCulture;
                        var azurePageIndex = autoCompleteContainer[0].dataset.azurePageIndex;
                        var azurePdfIndex = autoCompleteContainer[0].dataset.azurePdfIndex;

                        $.ajax({
                            url: "/api/AzureAiSearchAutocomplete",
                            data: {
                                text: text,
                                culture: culture,
                                azurePageIndex: azurePageIndex,
                                azurePdfIndex: azurePdfIndex
                            },
                            type: "GET",
                            success: function (data) {
                                if (data && data.length > 0) {
                                    currentSuggestion2 = data[0];
                                    add(data);
                                }
                            },
                            failure: function (response) {
                                console.log(response);
                            },
                            error: function (response) {
                                console.log(response);
                            }
                        });

                    }
                ]
            });

            // complete on TAB and clear on ESC
            $(".main-navbar__search-input").keydown(function (evt) {
                if (evt.keyCode === 9 /* TAB */) {
                    evt.preventDefault();
                    if (currentSuggestion2) {
                        var currentInput = $(".main-navbar__search-input").val(); // Get current input
                        var suggestion = currentSuggestion2; // The top suggestion

                        // Check if the current input is a prefix of the suggestion
                        if (suggestion.toLowerCase().startsWith(currentInput.toLowerCase())) {
                            var remainingText = suggestion.substring(currentInput.length); // Get remaining part of suggestion

                            // Append the remaining part to the current input
                            $(".main-navbar__search-input").val(currentInput + remainingText);
                        }
                    }
                } else if (evt.keyCode === 27 /* ESC */) {
                    currentSuggestion2 = "";
                    $(".main-navbar__search-input").val("");
                } else if (evt.keyCode === 13 /* ENTER */) { // Handle 'enter' key
                    evt.preventDefault(); // Prevent default form submission or refresh
                    $(".main-navbar__search-form").submit();
                }
            });
        });

        searchInputMain.addEventListener('input', function (textEvent) {
            var searchInputType = "main-nav";

            if (textEvent.target.value.length > 2 && autoCompleteContainer.length) {
                var culture = autoCompleteContainer[0].dataset.currentCulture;
                var azurePageIndex = autoCompleteContainer[0].dataset.azurePageIndex;
                var azurePdfIndex = autoCompleteContainer[0].dataset.azurePdfIndex;
                var searchResultPageLink = searchResultsContainer[0].dataset.searchResultPageLink;
                setTimeout(
                    azureSearch,
                    700,
                    textEvent, culture, azurePageIndex, azurePdfIndex, searchResultPageLink, searchInputType);
            } else {
                clearPredictiveSearchResults(searchInputType);
            }
        });

        searchInputMain.addEventListener("keydown", (evt) => {
            if (evt.key === "ArrowDown") {
                if (!document.activeElement.classList.contains("search-suggest__link")) {
                    evt.preventDefault();
                    $(".search-suggest__link:first").focus();
                    $(".search-suggest").off('keydown').on('keydown', function (evt) {
                        let activeDocument = document.activeElement;

                        if (evt.key === "ArrowDown" && activeDocument.parentElement.nextElementSibling != null) {
                            evt.preventDefault();
                            activeDocument.parentElement.nextElementSibling.firstElementChild.focus();
                        }
                        else if (evt.key === "ArrowDown" && activeDocument.parentElement.nextElementSibling == null) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            
                        }

                        if (evt.key === "ArrowUp" && activeDocument.parentElement.previousElementSibling != null) {
                            evt.preventDefault();
                            activeDocument.parentElement.previousElementSibling.firstElementChild.focus();
                        }
                        else if (evt.key === "ArrowUp" && activeDocument.parentElement.previousElementSibling == null) {
                            searchInputMain.focus();
                        }
                    });
                }
            }
        });
    }

    /**
     * Remove all DOM elements from the search results block element
     * @param {any} inputType block class to clear [main-nav|ANY OTHER]
     */
    function clearPredictiveSearchResults(inputType) {
        if (document.getElementsByClassName('search-suggest').length > 0) {
            var predictiveSearchResults;
            // delete from main navigation input element
            if (inputType === "main-nav") {
                predictiveSearchResults
                    = document.querySelector('.main-navbar .search-suggest');
            }
            // delete from search result page input element
            else {
                predictiveSearchResults
                    = document.querySelector('.bes-search-results .search-suggest');
            }
            predictiveSearchResults.remove(); // Clear the contents
        }
    }

    /**
     * Execute the Azure AI Search with given parameters using AJAX controller request
     * @param {any} textEvent text input event
     * @param {any} culture culture code of the language used in the search
     * @param {any} azurePageIndex codename of the page index to be used
     * @param {any} azurePdfIndex codename of the pdf index to be used
     * @param {any} inputType [main-nav|ANY OTHER]
     */
    function azureSearch(textEvent, culture, azurePageIndex, azurePdfIndex, searchResultPageLink, inputType) {
        $.ajax({
            url: "/api/AzureAiSearchSuggest",
            data: {
                text: textEvent.target.value,
                culture: culture,
                azurePageIndex: azurePageIndex,
                azurePdfIndex: azurePdfIndex,
                searchResultPageLink: searchResultPageLink
            },
            type: "GET",
            success: function (data) {
                buildAzureSearchSuggestions(data, inputType);
            },
            failure: function (response) {
                console.log(response);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }

    /**
     * Add suggestions to the DOM of the search results block
     * @param {any} data HTML to add to the block
     * @param {any} inputType where to add the results [main-nav|ANY OTHER]
     * @returns
     */
    function buildAzureSearchSuggestions(data, inputType) {
        if (data == undefined) {
            return;
        }
        if (inputType === "main-nav") {
            var predictiveSearchResults = document.querySelector('.main-navbar__predictive-search-results');
        } else {
            var predictiveSearchResults = document.querySelector('.bes-search-results__predictive-search-results');
        }
        if (data.length > 0) {
            predictiveSearchResults.innerHTML = data;
        }
    }

})(window.jQuery, window, document);
